import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority"

import { cn } from "../../lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center whitespace-nowrap font-medium ring-offset-background transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        default:
          "bg-[#10dfb2] text-black shadow-aqua hover:shadow-gold hover:scale-[1.02] active:scale-[0.98]",
        destructive:
          "bg-destructive text-destructive-foreground shadow-aqua hover:bg-destructive/90 hover:shadow-aqua-lg",
        outline:
          "border-2 border-[#10dfb2] bg-transparent text-[#10dfb2] shadow-aqua hover:bg-[#10dfb2] hover:text-black hover:shadow-gold",
        secondary:
          "bg-secondary text-secondary-foreground shadow-aqua hover:bg-secondary/80 hover:shadow-aqua-lg",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-11 px-6 py-2.5 rounded-full text-base",
        sm: "h-9 px-4 py-2 rounded-full text-sm",
        lg: "h-14 px-10 py-3.5 rounded-full text-lg font-semibold",
        icon: "h-10 w-10 rounded-full",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props}
    />
  )
})
Button.displayName = "Button"

export { Button, buttonVariants }
